// Shared BI page descriptors for the /tasks surface, imported by the page
// (page-load BI) and both brand bodies (click BI) so the page_name/version
// stay in one place across the fork.
export const TASKS_PAGE = { page_name: 'tasks_page' as const, page_version: 'v3_tasks_page' as const };
export const TASK_DETAILS_PAGE = { page_name: 'task_details' as const, page_version: 'v3_task_details' as const };
